import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';


export const LoadGLTFbyPath = (
    scene,
    loadingManager, 
    itemPath, 
    mPositionX, 
    mPositionY, 
    mPositionZ,

) => {
    return new Promise((resolve, reject) => {
        const loader = new GLTFLoader(loadingManager);

        loader.load(itemPath, (gltf) => {
            let model = gltf.scene;
            model.position.x = mPositionX;
            model.position.y = mPositionY;
            model.position.z = mPositionZ;

            model.rotation.x = 0;
            model.rotation.y = -Math.PI/4.5;
            model.rotation.z = 0;

            scene.add(model);

            resolve();
        }, undefined, (error) => {
            reject(error);
        });
    });
};

export function LODLoadGLTFbyPath (
    scene,
    loadingManager, 
    itemPath,
    mPositionX, 
    mPositionY, 
    mPositionZ,
    mScaleX,
    mScaleY,
    mScaleZ,
    isVisible,
    lodGroup,
    mIndex, 
    name

) {
        const loader = new GLTFLoader(loadingManager);

        loader.load(itemPath, (gltf) => {
            let model = gltf.scene;
            model.position.x = mPositionX;
            model.position.y = mPositionY;
            model.position.z = mPositionZ;

            model.scale.x = mScaleX;
            model.scale.y = mScaleY;
            model.scale.z = mScaleZ;

            model.rotation.y = Math.PI/3.2;

            if (model.userData.name === undefined) {
                model.userData.name = name;
            }

            model.visible = isVisible;

            scene.add(model);
            lodGroup[mIndex] = model;
        })

};

export function LoadGLTFImagePanelbyPath (
    scene,
    loadingManager, 
    itemPath,
    isVisible,
    iPGroup,
    iPIndex,

) {
        const loader = new GLTFLoader(loadingManager);

        loader.load(itemPath, (gltf) => {
            let model = gltf.scene;

            model.position.x = -1;
            model.position.y = 0;
            model.position.z = 0.06;

            model.rotation.y = Math.PI/-4.5;

            model.visible = isVisible;

            scene.add(model);
            iPGroup[iPIndex] = model;
        })

};

export function LoadGLTFGamebyPath (
    scene,
    loadingManager, 
    itemPath,
    mPositionX,
    mPositionY,
    mPositionZ,
    iPGroup,
    iPIndex

) {
        const loader = new GLTFLoader(loadingManager);

        loader.load(itemPath, (gltf) => {
            let model = gltf.scene;

            model.position.x = mPositionX
            model.position.y = mPositionY
            model.position.z = mPositionZ

            model.rotation.y = Math.PI/-4.5;

            scene.add(model);
            iPGroup[iPIndex] = model;
        })

};

export function LoadGLTFProgressPanelbyPath (
    scene,
    loadingManager, 
    itemPath,
    mPositionX,
    mPositionY,
    mPositionZ,
    isVisible,
    iPGroup,
    iPIndex,

) {
        const loader = new GLTFLoader(loadingManager);

        loader.load(itemPath, (gltf) => {
            let model = gltf.scene;

            model.position.x = mPositionX;
            model.position.y = mPositionY;
            model.position.z = mPositionZ;

            model.rotation.y = Math.PI/-4.5;

            model.visible = isVisible;

            scene.add(model);
            iPGroup[iPIndex] = model;
        })

};

export function LoadGLTFSkybyPath (
    scene,
    loadingManager, 
    itemPath,
    sGroup

) {
        const loader = new GLTFLoader(loadingManager);

        loader.load(itemPath, (gltf) => {
            let model = gltf.scene;

            model.position.x = 0;
            model.position.y = 0;
            model.position.z = 0;

            model.rotation.y = Math.PI/-4.5;

            scene.add(model);
            sGroup[0] = model;
        })

};

